<template>
  <div class="article article--listing article--horizontal">
  <div class="article__link">
    <template v-if="showThumbnail">
      <picture v-if="getFieldValue(result.Fields, 'Image') && getFieldValue(result.Fields, 'Image') !== 'https://www.bristol.ac.uk'" class="article__image">
        <img class="ls-is-cached lazyloaded" :src="'https://www.bristol.ac.uk' + getFieldValue(result.Fields, 'Image')" alt="">
      </picture>
      <picture v-else class="article__image">
        <img class="lazyload" alt="Article Image" :src="require('@/assets/fallback-image.svg')">
      </picture>
    </template>
    <div class="article__content">
      <!-- <div class="badge-group">
        <span class="badge" v-for="category in getNewsCategory" :key="category">
          {{ category }}
        </span>
      </div> -->
      <h6 class="article__title">{{ getFieldValue(result.Fields, 'Title') }} </h6>
      <time> {{ getNewsDate }} </time>
      <p class="article__description" v-html="getFieldValue(result.Fields, 'Description', 'Unknown', true)"></p>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'SearchResult',
  props: {
    result: {
      type: Object,
      required: true,
    },
    showThumbnail: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getNewsDate() {
      return (
        `${this.getFieldValue(this.result.Fields, 'Day')} ${this.capitalise(this.getFieldValue(this.result.Fields, 'Month'))} ${this.getFieldValue(this.result.Fields, 'Year')}`
      );
    },
    // This method returns news Category.
    getNewsCategory() {
      const newsCategory = this.getFieldValue(this.result.Fields, 'NewsCategory');
      //if there are multiple categories, split them into an array, otherwise return the single category in an array for consistency
      if (newsCategory) {
        return newsCategory.includes(',') ? newsCategory.split(',').map(category => category.trim()) : [newsCategory.trim()];
      }
      return newsCategory;
    }
  },
  methods: {
    getFieldValue(
      fields,
      fieldName,
      defaultValue = undefined,
      returnHighlights = false
    ) {
      // Assign field to a constant
      const field = fields[fieldName];
      // Verify that the field exists
      if (field) {
        // Assign field value to variable so it can be trimmed
        let fieldValue = field.Value;
        // Initialise field higlights with trimmed field value
        let fieldHighlights = fieldValue;
        // Verify that highlights exist on this field
        if (field.Highlights && field.Highlights.length > 0) {
          // Update field higlights to the first highlight only
          fieldHighlights = field.Highlights.join(' ');
        }
        // Return trimmed field value or joined highlights
        return returnHighlights ? fieldHighlights : fieldValue;
      }
      // The field does not exist, return the default string
      return defaultValue;
    },
    capitalise(string = '') {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
